import type { Guide } from '../types';

/** Address, name, search title and description of the guide in each language (menus, cards, links). */
export const beachesGuide: Guide = {
  id: 'praias-e-ilhas',
  imageTour: 'lancha-privada-praiana',
  published: '2026-10-23',
  updated: '2026-10-23',
  tours: [
    'Passeio-em-aquamarina-ll',
    'passeio-em-escuna-poseidon',
    'saco-de-mamangua-lancha-rapida',
    'lancha-privada-praiana',
  ],
  copy: {
    pt: {
      slug: 'praias-e-ilhas-de-paraty',
      label: 'Praias e ilhas de Paraty',
      title: 'Praias e Ilhas de Paraty: Ilha dos Cocos, Lagoa Azul e Mais',
      description: 'As praias e ilhas de Paraty que você conhece de barco: Ilha dos Cocos, Lagoa Azul, Praia da Lula, Praia Vermelha, Ilha Comprida e Saco da Velha. Veja qual passeio leva a cada uma.',
    },
    es: {
      slug: 'playas-e-islas-de-paraty',
      label: 'Playas e islas de Paraty',
      title: 'Playas e Islas de Paraty: Ilha dos Cocos, Lagoa Azul y Más',
      description: 'Las playas e islas de Paraty que conoces en barco: Ilha dos Cocos, Lagoa Azul, Praia da Lula, Praia Vermelha, Ilha Comprida y Saco da Velha. Mira qué paseo va a cada una.',
    },
    en: {
      slug: 'paraty-beaches-and-islands',
      label: 'Paraty beaches and islands',
      title: 'Paraty Beaches and Islands: Ilha dos Cocos, Lagoa Azul and More',
      description: 'The beaches and islands of Paraty you reach by boat: Ilha dos Cocos, Lagoa Azul, Praia da Lula, Praia Vermelha, Ilha Comprida and Saco da Velha. See which tour goes to each one.',
    },
    fr: {
      slug: 'plages-et-iles-de-paraty',
      label: 'Plages et îles de Paraty',
      title: 'Plages et Îles de Paraty : Ilha dos Cocos, Lagoa Azul et Plus',
      description: 'Les plages et îles de Paraty accessibles en bateau : Ilha dos Cocos, Lagoa Azul, Praia da Lula, Praia Vermelha, Ilha Comprida et Saco da Velha. Quelle excursion mène à chacune.',
    },
  },
};
